export default {
    topics: [
        {
            title: ' Schema (Class) ',
            href: 'c-Schema.html',
            attributes: { 'data-id': 'c-Schema' },
            menu: { hasChildren: false },
            tocID: 'c-Schema-d66e5999',
            next: 'c-Schema-d66e5999',
        },
        {
            title: ' SchemaNode (Class) ',
            href: 'c-SchemaNode.html',
            attributes: { 'data-id': 'c-SchemaNode' },
            menu: { hasChildren: false },
            tocID: 'c-SchemaNode-d66e6087',
            next: 'c-SchemaNode-d66e6087',
        },
        {
            title: ' SchemaKey (Class) ',
            href: 'c-SchemaKey.html',
            attributes: { 'data-id': 'c-SchemaKey' },
            menu: { hasChildren: false },
            tocID: 'c-SchemaKey-d66e6564',
            next: 'c-SchemaKey-d66e6564',
        },
        {
            title: ' Enumeration (Class) ',
            href: 'c-Enumeration.html',
            attributes: { 'data-id': 'c-Enumeration' },
            menu: { hasChildren: false },
            tocID: 'c-Enumeration-d66e6620',
            next: 'c-Enumeration-d66e6620',
        },
        {
            title: ' EnumerationValue (Class) ',
            href: 'c-EnumerationValue.html',
            attributes: { 'data-id': 'c-EnumerationValue' },
            menu: { hasChildren: false },
            tocID: 'c-EnumerationValue-d66e6684',
            next: 'c-EnumerationValue-d66e6684',
        },
    ],
};

